import React from "react";
import { useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useTableSgcConfigurationsConfig } from "./hooks";

export const SgcConfigurationsSelectStation = (props) => {
  const { size = "small" } = props;
  const { handleChangeStation } = useTableSgcConfigurationsConfig();
  const { stationsList } = useSelector(({ companies }) => companies);
  const { station, deleteMode } = useSelector(({ sgcConfigurations }) => sgcConfigurations);

  return (
    <Autocomplete
      id="combo-box-demo"
      options={stationsList}
      value={station}
      filterSelectedOptions
      disabled={deleteMode}
      getOptionLabel={(option) => option.label ? option.label : option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          name="stations"
          label="Planta"
          variant="outlined"
          size={size}
          disabled={deleteMode}
        />
      )}
      fullWidth
      onChange={(e, v) => handleChangeStation(e, v)}
      noOptionsText="No se encuentra la planta"
    />
  );
};
